export const CURRENT_NAVIGATIONMENU_SET = "CURRENT_NavigationMenu_Set";
export const CURRENT_NAVIGATIONMENU_RELOAD = "CURRENT_NavigationMenu_Reload";